import * as React from "react";
import Svg, { Path } from "react-native-svg";

import { useViewport } from "@/contexts/ViewportContext";

export default function SvgComponent(props) {
  const { isWebMode } = useViewport();
  return isWebMode ? (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={1200}
      height={563}
      viewBox="0 0 1200 563"
      {...props}>
      <Path
        vectorEffect="non-scaling-stroke"
        d="M-180 474.5v-759a90 90 0 0190-90h270v849zm360.008-849h-100a99.332 99.332 0 0070.674-29.322 99.316 99.316 0 0029.326-70.678z"
        transform="matrix(2.01 0 0 2.17 564.02 327.52) translate(-123.73 732.88) scale(1.2)"
        stroke="none"
        strokeWidth={22}
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeDashoffset={0}
        strokeLinejoin="miter"
        strokeMiterlimit={4}
        fill="#fff"
        fillRule="nonzero"
        opacity={1}
      />
      <Path
        d="M-180 474.5v-759a90 90 0 0190-90h270v849zm360.008-849h-100a99.332 99.332 0 0070.674-29.322 99.316 99.316 0 0029.326-70.678z"
        transform="matrix(2.01 0 0 2.17 564.02 327.52) matrix(1.78 0 0 1.78 -2.95 634.54)"
        stroke="none"
        strokeWidth={1}
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeDashoffset={0}
        strokeLinejoin="miter"
        strokeMiterlimit={4}
        fill="#fff"
        fillRule="nonzero"
        opacity={1}
      />
    </Svg>
  ) : (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={640}
      height={480}
      viewBox="0 0 640 480"
      {...props}>
      <Path
        vectorEffect="non-scaling-stroke"
        d="M-180 474.5v-759a90 90 0 0190-90h270v849zm360.008-849h-100a99.332 99.332 0 0070.674-29.322 99.316 99.316 0 0029.326-70.678z"
        transform="translate(196.27 972.88) scale(1.2)"
        stroke="none"
        strokeWidth={22}
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeDashoffset={0}
        strokeLinejoin="miter"
        strokeMiterlimit={4}
        fill="#fff"
        fillRule="nonzero"
        opacity={1}
      />
      <Path
        d="M-180 474.5v-759a90 90 0 0190-90h270v849zm360.008-849h-100a99.332 99.332 0 0070.674-29.322 99.316 99.316 0 0029.326-70.678z"
        transform="matrix(1.78 0 0 1.78 317.04 874.54)"
        stroke="none"
        strokeWidth={1}
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeDashoffset={0}
        strokeLinejoin="miter"
        strokeMiterlimit={4}
        fill="#fff"
        fillRule="nonzero"
        opacity={1}
      />
    </Svg>
  );
}
